import { Card } from "@portal/BaseComponents/Card/AntCard";
import { styled } from "@stitches/react";


export const StyledCommentBox = styled(Card, {
  backgroundColor: "var(--gray-2)",
  borderRadius: 0,
  ".ant-card-actions": {
    borderRadius: 0,
    border: 0,

    li: {
      margin: 0,
      height: "56px",
    },
  },
});
